import Button from "@mui/material/Button";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormGroup from "@mui/material/FormGroup";
import FormLabel from "@mui/material/FormLabel";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { useTranslation } from "react-i18next";
import { WAITLIST_TOPIC_IDS } from "../../../../lib/waitlist";
import { Note } from "../../../primitives/data-display/Note";
import { gaps } from "../../../primitives/spacing";
import { useWaitlistForm } from "./useWaitlistForm";

/** Sign-up to be told when RealityCheq covers more topics: name, email and the topics of interest. */
export function WaitlistForm() {
  const { t } = useTranslation();
  const form = useWaitlistForm();

  if (form.submitted) {
    return (
      <Stack direction="row" gap={gaps.snug} sx={{ alignItems: "center", color: "success.main" }}>
        <CheckCircleOutlineIcon />
        <Note color="inherit">{t("waitlist.success", { email: form.email.trim() })}</Note>
      </Stack>
    );
  }

  return (
    <Stack
      component="form"
      noValidate
      gap={gaps.base}
      onSubmit={(e) => {
        e.preventDefault();
        void form.handleSubmit();
      }}
    >
      <Stack direction={{ xs: "column", sm: "row" }} gap={gaps.snug}>
        <TextField
          label={t("waitlist.firstName")}
          name="FNAME"
          autoComplete="given-name"
          required
          size="small"
          fullWidth
          value={form.firstName}
          onChange={(e) => form.setFirstName(e.target.value)}
        />
        <TextField
          label={t("waitlist.lastName")}
          name="LNAME"
          autoComplete="family-name"
          required
          size="small"
          fullWidth
          value={form.lastName}
          onChange={(e) => form.setLastName(e.target.value)}
        />
      </Stack>
      <TextField
        label={t("waitlist.email")}
        name="EMAIL"
        type="email"
        autoComplete="email"
        required
        size="small"
        fullWidth
        value={form.email}
        onChange={(e) => form.setEmail(e.target.value)}
        error={form.emailInvalid}
        helperText={form.emailInvalid ? t("waitlist.emailInvalid") : undefined}
      />

      <FormGroup>
        <FormLabel>{t("waitlist.topics")}</FormLabel>
        {WAITLIST_TOPIC_IDS.map((id) => (
          <FormControlLabel
            key={id}
            label={t(`waitlist.topic.${id}`)}
            control={
              <Checkbox
                size="small"
                checked={form.topics.isSelected(id)}
                onChange={() => form.topics.toggle(id)}
              />
            }
          />
        ))}
      </FormGroup>

      {form.error !== null && <Note color="error.main">{t("waitlist.error")}</Note>}

      <Button
        type="submit"
        variant="contained"
        disabled={form.submitting}
        loading={form.submitting}
      >
        {t("waitlist.submit")}
      </Button>
    </Stack>
  );
}
